import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Cake, Heart } from "lucide-react";
import { PageHead, Panel, Stat, WaButton, itDate } from "@/components/kit";
import { StatusBadge } from "@/components/StatusBadge";
import { api, errMsg, fmtMoney } from "@/lib/api";

const Row = ({ to, children, testId }) => <Link to={to} className="flex flex-wrap justify-between gap-2 text-sm py-2.5 border-b border-[#EAF5F7] last:border-0 hover:text-[#0B6E8F]" data-testid={testId}>{children}</Link>;

export default function ClientProfile() {
  const [params] = useSearchParams();
  const nome = params.get("nome") || "";
  const tel = params.get("tel") || "";
  const [h, setH] = useState(null);
  useEffect(() => {
    api.get("/client-history", { params: { nome, tel } }).then((r) => setH(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [nome, tel]);
  if (!h) return <div className="text-sm text-[#7B929C]">Caricamento…</div>;
  const t = h.totali;
  return (
    <div className="space-y-8" data-testid="client-profile">
      <PageHead eyebrow={`Scheda cliente ${tel ? `• ${tel}` : ""}`} title={nome || tel}>
        <WaButton phone={tel} testId="client-profile-wa" text={`🌟 Gentile *${nome}*,\n\n✨ un caro saluto da tutto lo staff!\n\nUn cordiale saluto 🌊`} />
      </PageHead>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat dark label="Eventi firmati" value={t.eventi} testId="client-kpi-events" />
        <Stat label="Valore totale" value={fmtMoney(t.valore)} testId="client-kpi-value" />
        <Stat label="Pagato" value={fmtMoney(t.pagato)} testId="client-kpi-paid" />
        <Stat label="Da incassare" value={fmtMoney(t.residuo)} testId="client-kpi-due" />
      </div>
      <div className="grid lg:grid-cols-2 gap-6 items-start">
        <Panel title="Contratti" testId="client-contracts">
          {h.contracts.length === 0 && <div className="text-sm text-[#7B929C]">Nessun contratto.</div>}
          {h.contracts.map((c) => <Row key={c.id} to={`/contratti/${c.id}`} testId={`client-contract-${c.number}`}><span><b>{c.number}</b> • {c.tipo} {itDate(c.data)} <span className="ml-1"><StatusBadge status={c.status} /></span></span><span className="text-xs text-[#47606B]">{fmtMoney(c.totale)} • pagato {fmtMoney(c.pagato)}</span></Row>)}
        </Panel>
        <Panel title="Preventivi" testId="client-quotes">
          {h.quotes.length === 0 && <div className="text-sm text-[#7B929C]">Nessun preventivo.</div>}
          {h.quotes.map((q) => <Row key={q.id} to={`/preventivi/${q.id}`} testId={`client-quote-${q.number}`}><span><b>{q.number}</b> • {q.tipo} {itDate(q.data)} • {q.status}</span><span className="text-xs">{fmtMoney(q.totale)}</span></Row>)}
        </Panel>
        <Panel title="Date da ricordare" testId="client-dates">
          {h.ricorrenze.length === 0 && <div className="text-sm text-[#7B929C]">Nessuna ricorrenza.</div>}
          {h.ricorrenze.map((r, i) => <div key={i} className="flex items-center gap-2 text-sm">{r.tipo === "Compleanno" ? <Cake size={14} className="text-[#0B6E8F]" /> : <Heart size={14} className="text-[#0B6E8F]" />}{r.tipo} • {r.persona} • {itDate(r.data)} <span className="text-xs text-[#7B929C]">(prossimo {itDate(r.prossima)})</span></div>)}
        </Panel>
        <Panel title="Richieste e appuntamenti" testId="client-activity">
          {h.leads.length + h.appointments.length === 0 && <div className="text-sm text-[#7B929C]">Nessuna attività.</div>}
          {h.leads.map((l) => <Row key={l.id} to="/richieste"><span>Richiesta • {l.tipo} {itDate(l.data)} • fase {l.stage}</span><span className="text-xs text-[#7B929C]">{l.fonte}</span></Row>)}
          {h.appointments.map((a) => <Row key={a.id} to="/calendario"><span>{a.tipo} • {itDate(a.data_ora)} {a.data_ora.slice(11, 16)}</span><span className="text-xs text-[#7B929C]">{a.sede}</span></Row>)}
        </Panel>
      </div>
    </div>
  );
}
